import axios from 'axios';
import { toast } from 'react-toastify';

import call from '../../../core/services/http';
import { BASE_URL } from '../../../core/environment/environment';
import { getToken } from '../../../shared/auth/authService';
import {
    CREATE_ASSET_ERROR,
    CREATE_ASSET_REQUEST,
    CREATE_ASSET_SUCCESS,
    DELETE_ASSET_ERROR,
    DELETE_ASSET_REQUEST,
    DELETE_ASSET_SUCCESS,
    GET_ASSETS_ERROR,
    GET_ASSETS_REQUEST,
    GET_ASSETS_SUCCESS,
    GET_ASSET_ERROR,
    GET_ASSET_REQUEST,
    GET_ASSET_SUCCESS,
    GET_ASSET_TRANSFERS_ERROR,
    GET_ASSET_TRANSFERS_REQUEST,
    GET_ASSET_TRANSFERS_SUCCESS,
    GET_ASSET_TRANSFER_ITEMS_ERROR,
    GET_ASSET_TRANSFER_ITEMS_REQUEST,
    GET_ASSET_TRANSFER_ITEMS_SUCCESS,
    GET_ASSET_TRANSFER_HISTORY_ERROR,
    GET_ASSET_TRANSFER_HISTORY_REQUEST,
    GET_ASSET_TRANSFER_HISTORY_SUCCESS,
    GET_AUDIT_ASSETS_ERROR,
    GET_AUDIT_ASSETS_REQUEST,
    GET_AUDIT_ASSETS_SUCCESS,
    TRANSFER_ASSET_ERROR,
    TRANSFER_ASSET_REQUEST,
    TRANSFER_ASSET_SUCCESS,
    UPDATE_ASSET_ERROR,
    UPDATE_ASSET_REQUEST,
    UPDATE_ASSET_SUCCESS,
    UPDATE_TRANSFER_STATUS_ERROR,
    UPDATE_TRANSFER_STATUS_REQUEST,
    UPDATE_TRANSFER_STATUS_SUCCESS,
    UPLOAD_ASSET_ERROR,
    UPLOAD_ASSET_REQUEST,
    UPLOAD_ASSET_SUCCESS,
} from './assetActionTypes';
import assetConstants from './assetConstants';

const toastrSuccess = (msg) => {
  toast.success(msg);
};
const toastrError = (msg) => {
  toast.error(msg);
};

export const getAssets = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSETS_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_ASSETS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_ASSETS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const getAuditAssets = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_AUDIT_ASSETS_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_AUDIT_ASSETS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_AUDIT_ASSETS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_AUDIT_ASSETS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_AUDIT_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_AUDIT_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const getAssetTransfers = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSET_TRANSFERS_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_ASSET_TRANSFERS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_ASSET_TRANSFERS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSET_TRANSFERS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFERS_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFERS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const getAssetTransferHistory = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSET_TRANSFER_HISTORY_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_ASSET_TRANSFER_HISTORY(payload));
    if (response.data.status) {
      dispatch({
        type: GET_ASSET_TRANSFER_HISTORY_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSET_TRANSFER_HISTORY_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFER_HISTORY_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFER_HISTORY_ERROR,
        isLoading: false,
        isSuccess: false,
      });
      toastrError(errorMessage);
    } else {
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const exportAssetTransfers = (filters = {}) => async () => {
  try {
    const token = getToken();
    if (!token) {
      toast.error('Authentication required. Please log in again.');
      return;
    }
    const url = `${BASE_URL}${assetConstants.EXPORT_ASSET_TRANSFERS(filters)}`;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
      timeout: 30000,
    });
    if (response.status === 200 && response.data instanceof Blob && response.data.size > 0) {
      const blob = new Blob([response.data], { type: 'text/csv' });
      const objectUrl = window.URL.createObjectURL(blob);
      const filename = `asset_transfers_${new Date().toISOString().slice(0, 10)}.csv`;
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
      toast.success(`Transfers exported as ${filename}`);
    } else {
      toast.error('Export failed: empty response');
    }
  } catch (error) {
    toast.error('Failed to export transfers');
  }
};

export const filterAssets = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSETS_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.FILTER_ASSETS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_ASSETS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSETS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const getAssetDetail = (id) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSET_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_ASSET(id));
    if (response.data.status) {
      dispatch({
        type: GET_ASSET_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSET_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const getAssetTransferItems = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_ASSET_TRANSFER_ITEMS_REQUEST,
      isLoading: true,
    });
    const response = await call('get', assetConstants.GET_ASSET_TRANSFER_ITEMS(payload));
    if (response.data.status) {
      dispatch({
        type: GET_ASSET_TRANSFER_ITEMS_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_ASSET_TRANSFER_ITEMS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFER_ITEMS_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_ASSET_TRANSFER_ITEMS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const transferAsset = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: TRANSFER_ASSET_REQUEST,
      isLoading: true,
      isSuccess: false,
    });
    const response = await call('post', assetConstants.TRANSFER_ASSET, payload);
    if (response.data.status) {
      dispatch({
        type: TRANSFER_ASSET_SUCCESS,
        isLoading: false,
        isSuccess: true,
        payload: response.data,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: TRANSFER_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: TRANSFER_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: TRANSFER_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const createAsset = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_ASSET_REQUEST,
      isLoading: true,
      isSuccess: false,
    });
    const response = await call('post', assetConstants.CREATE_ASSET, payload);
    if (response.data.status) {
      dispatch({
        type: CREATE_ASSET_SUCCESS,
        isLoading: false,
        isSuccess: true,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: CREATE_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: CREATE_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: CREATE_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const uploadAssets = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: UPLOAD_ASSET_REQUEST,
      isLoading: true,
      isUploading: true,
    });
    const response = await call('post', assetConstants.UPLOAD_ASSET, payload);
    if (response.data.status) {
      dispatch({
        type: UPLOAD_ASSET_SUCCESS,
        isLoading: false,
        isUploading: false,
        payload: response.data,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: UPLOAD_ASSET_ERROR,
        isLoading: false,
        isUploading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPLOAD_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPLOAD_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const approveTransfer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_TRANSFER_STATUS_REQUEST,
      isLoading: true,
    });
    const response = await call('post', assetConstants.APPROVE_ASSET_TRANSFER(id));
    if (response.data.status) {
      dispatch({
        type: UPDATE_TRANSFER_STATUS_SUCCESS,
        isLoading: false,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const declineTransfer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_TRANSFER_STATUS_REQUEST,
      isLoading: true,
    });
    const response = await call('post', assetConstants.DECLINE_ASSET_TRANSFER(id));
    if (response.data.status) {
      dispatch({
        type: UPDATE_TRANSFER_STATUS_SUCCESS,
        isLoading: false,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};
export const acceptTransfer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_TRANSFER_STATUS_REQUEST,
      isLoading: true,
    });
    const response = await call('post', assetConstants.ACCEPT_ASSET_TRANSFER(id));
    if (response.data.status) {
      dispatch({
        type: UPDATE_TRANSFER_STATUS_SUCCESS,
        isLoading: false,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const rejectTransfer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_TRANSFER_STATUS_REQUEST,
      isLoading: true,
    });
    const response = await call('post', assetConstants.REJECT_ASSET_TRANSFER(id));
    if (response.data.status) {
      dispatch({
        type: UPDATE_TRANSFER_STATUS_SUCCESS,
        isLoading: false,
      });
      toastrSuccess(response.data.message);
    } else {
      toastrError(response.data.message);
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: UPDATE_TRANSFER_STATUS_ERROR,
        isLoading: false,
        isSuccess: false,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError(error?.response?.data?.message || 'Sorry, something went wrong');
    }
  }
};

export const updateAsset =
  ({ id, payload }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_ASSET_REQUEST,
        isLoading: true,
        isSuccess: false,
      });
      const response = await call('patch', assetConstants.UPDATE_ASSET(id), payload);
      if (response.data.status) {
        dispatch({
          type: UPDATE_ASSET_SUCCESS,
          isLoading: false,
          isSuccess: true,
          message: response.data.message,
        });
        toastrSuccess(response.data.message);
      } else {
        toastrError(response.data.message);
        dispatch({
          type: UPDATE_ASSET_ERROR,
          isLoading: false,
          isSuccess: false,
          message: response.data.message,
        });
      }
    } catch (e) {
      dispatch({
        type: UPDATE_ASSET_ERROR,
        isLoading: false,
        isSuccess: false,
      });
      toastrError(e?.response?.data?.message || 'Sorry, something went wrong');
    }
  };
